<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户反馈</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索筛选 -->
    <el-form :inline="true" style="margin-top: 20px;">
      <el-form-item>
        <el-input size="small" v-model="keyword" placeholder="请输入用戶手机号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="chongzhi">重置</el-button>
      </el-form-item>
    </el-form>

    <!-- 列表 -->
    <el-table size="small" :data="feedData" element-loading-text="拼命加载中" border>
      <!-- <el-table-column align="center" sortable prop="id" label="编号"></el-table-column> -->
      <el-table-column align="center" sortable type="index" label="序号"></el-table-column>
      <el-table-column align="center" sortable prop="nickName" label="用户昵称"></el-table-column>
      <el-table-column align="center" sortable prop="mobile" label="手机号"></el-table-column>
      <el-table-column align="center" prop="avatar" label="用户头像">
        <template slot-scope="scope">
          <el-image v-if="scope.row.avatar" style="width: 40px;height: 40px;" :src="scope.row.avatar"
            :preview-src-list="[scope.row.avatar]"></el-image>
          <div v-if="scope.row.avatar == null">没有图片</div>
        </template>
      </el-table-column>
      <el-table-column align="center" sortable prop="content" label="反馈内容"></el-table-column>
      <el-table-column align="center" prop="urls" label="反馈图片">
        <template slot-scope="scope">
          <el-image v-if="scope.row.urls" style="width: 90px;height: 90px;" :src="scope.row.urls"
            :preview-src-list="[scope.row.urls]"></el-image>
          <div v-if="scope.row.urls == null">没有图片</div>
          <div v-if="scope.row.urls == ''">暂无图片</div>
        </template>
      </el-table-column>
      <el-table-column align="center" sortable prop="reply" label="回复内容"></el-table-column>
      <el-table-column align="center" sortable prop="createTime" label="创建时间">
        <template slot-scope="scope">
          <div>{{ transformDate(scope.row.createTime) }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="upFeed(scope.row.id)">回复</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

  </div>
</template>

<script>
import { getFeedback } from '../../api/userMG';
import { responseFeedback } from '../../api/userMG'
import Pagination from '../../components/Pagination'

export default {
  data() {
    return {
      keyword: '',

      // 用户数据
      feedData: [],

      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10
      },

      loading: false
    }

  },
  // 注册组件
  components: {
    Pagination
  },
  created() {
    this.getdata(1);
  },
  methods: {
    // 分页插件事件
    callFather(parm) {
      this.pageparm.page = parm.currentPage
      this.getdata(parm.currentPage)
    },
    // 回复
    upFeed(row) {
      console.log(row)
      this.$prompt('请输入回复内容', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^(?!(\s+$))/,
        inputErrorMessage: '不可以空数据提交!'
      }).then(({ value }) => {
        let data = {
          id: row,
          reply: value
        }
        responseFeedback(data).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg)
            this.getdata(1)
          } else {
            this.$message.error(res.msg);
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
      });
    },

    // 搜索数据
    search() {
      this.getdata(1)
    },
    // 重置数据
    chongzhi() {
      this.keyword = ''
      this.getdata(1)
    },

    // 获取数据
    getdata(page) {
      this.loading = true;
      // page = (page - 1) * 20;
      // 获取反馈列表
      var parameter = {
        page: (page - 1) * 20,
        keyword: this.keyword,
      };
      console.log("parameter", parameter)

      getFeedback(parameter).then((res) => {
        console.log('res.data', res)
        this.loading = false;
        if (res.code != 200) {
          this.$Message({
            type: "info",
            message: res.msg,
          });
        } else {
          this.feedData = res.data.list;
          this.pageparm.currentPage = page;
          this.pageparm.total = res.data.count;
          return;
        }
      })

    }
  }
}
</script>

<style></style>


// WEBPACK FOOTER //
// src/views/terrace/Feedback.vue